// Composant pour gérer le consentement aux cookies
import React, { useState, useEffect } from 'react';
import { Shield, X, Check } from 'lucide-react';
import { useAnalyticsContext } from './AnalyticsProvider';

const CookieConsent: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);
  const { hasConsent, updateConsent } = useAnalyticsContext();

  useEffect(() => {
    // Afficher la bannière si aucun choix n'a été fait
    const storedConsent = localStorage.getItem('analytics_consent');
    if (storedConsent === null) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    updateConsent(true);
    setShowBanner(false);
  };

  const handleDecline = () => {
    updateConsent(false);
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-start space-x-3 flex-1">
            <Shield className="h-6 w-6 text-primary flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">
                Respect de votre vie privée
              </h3>
              <p className="text-sm text-gray-600">
                Nous utilisons Google Analytics pour améliorer votre expérience sur SimulReno. 
                Ces données nous aident à comprendre comment vous utilisez notre service et à l'améliorer. 
                Vos données sont anonymisées et nous ne les partageons jamais avec des tiers.
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3 flex-shrink-0">
            <button
              onClick={handleDecline}
              className="px-4 py-2 text-gray-600 hover:text-gray-800 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex items-center"
            >
              <X className="h-4 w-4 mr-2" />
              Refuser
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors flex items-center"
            >
              <Check className="h-4 w-4 mr-2" />
              Accepter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;